/**
 * @generated SignedSource<<de14affd4043734691bb95f76c1bad3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreFlag = "Calendar" | "CustomerFeedback" | "EmployeeRole" | "GroupAccountsAndProfiles" | "MigratedTeamSchedule" | "OnbardedTeams" | "Product" | "ProductDateTracker" | "SignalWidget" | "TodoAsIssue" | "TodoNewTimlineAndComments" | "VersionSummer24";
export type StoreSuperAdminPanelEnableFlagMutation$variables = {
  flag: StoreFlag;
  storeId: string;
};
export type StoreSuperAdminPanelEnableFlagMutation$data = {
  readonly store: {
    readonly _adminDisableFlag: {
      readonly flags: ReadonlyArray<StoreFlag>;
    };
  };
};
export type StoreSuperAdminPanelEnableFlagMutation$rawResponse = {
  readonly store: {
    readonly _adminDisableFlag: {
      readonly flags: ReadonlyArray<StoreFlag>;
      readonly id: string;
    };
  };
};
export type StoreSuperAdminPanelEnableFlagMutation = {
  rawResponse: StoreSuperAdminPanelEnableFlagMutation$rawResponse;
  response: StoreSuperAdminPanelEnableFlagMutation$data;
  variables: StoreSuperAdminPanelEnableFlagMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flag"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "flag",
    "variableName": "flag"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flags",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreSuperAdminPanelEnableFlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "_adminDisableFlag",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StoreSuperAdminPanelEnableFlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "_adminDisableFlag",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3c9b6c6d8540cf6f592b57abe6735bf",
    "id": null,
    "metadata": {},
    "name": "StoreSuperAdminPanelEnableFlagMutation",
    "operationKind": "mutation",
    "text": "mutation StoreSuperAdminPanelEnableFlagMutation(\n  $storeId: ID!\n  $flag: StoreFlag!\n) {\n  store(id: $storeId) {\n    _adminDisableFlag(flag: $flag) {\n      flags\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d66488cd9d377a4e8fb078a81d4a775";

export default node;
